import { Controller } from "@hotwired/stimulus"

/**
 * Privacy Radio Controller
 * 
 * Manages radio button icon colors for privacy/domain restrictions.
 * Updates icon colors based on radio button checked state.
 * 
 * Usage: Add data-controller="privacy-radio" to the privacy-radio input element
 *        The icon should be the next sibling element with class "privacy-icon"
 */
export default class extends Controller {
  static targets = ["icon"]
  
  connect() {
    this.updateIconColor()
  }
  
  change() {
    this.updateIconColor()
    // Update all radios in the same section
    this.updateAllIconsInSection()
  }
  
  updateIconColor() {
    const icon = this.element.nextElementSibling
    if (icon && icon.classList.contains('privacy-icon')) {
      if (this.element.checked) {
        icon.style.color = '#000000' // Black when checked
      } else {
        icon.style.color = '#d1d5db' // Light gray when unchecked
      }
    }
  }
  
  updateAllIconsInSection() {
    // Find all radios in the same privacy-section
    const section = this.element.closest('.privacy-section')
    if (section) {
      section.querySelectorAll('.privacy-radio').forEach(radio => {
        const icon = radio.nextElementSibling
        if (icon && icon.classList.contains('privacy-icon')) {
          if (radio.checked) {
            icon.style.color = '#000000'
          } else {
            icon.style.color = '#d1d5db'
          }
        }
      })
    }
  }
}
